import React from 'react';

import DiceRoller from './DiceRoller'

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';



const useToolbarStyles = makeStyles((theme) => ({
  divGridDiceList: {
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
    marginBottom: '40px',
    marginTop: '40px',
    border: '2px solid white',
    height: 'auto',
  },
}));

const Dices = () => {
  const classes = useToolbarStyles();

  

  return (
    <div className={classes.divGridDiceList}>
      <Grid
        container
        spacing={1}
        className={classes.gridDiceList}
        direction="row"
        justify="center"
        alignItems="center"
        col={12}>
        {
          ['d3', 'd4', 'd6', 'd8', 'd10', 'd12', 'd20', 'd100'].map((diceValue) =>
            <Grid xs={6} sm={3} key={diceValue} item>
              <DiceRoller skillName={diceValue.toUpperCase()} skillValue={"Rolar"} dice={diceValue} />
            </Grid>
          )
        }
      </Grid>
    </div>

  );
}

export default Dices;